export default __webpack_public_path__ + "static/media/LogoB.86ee124c.png";